import React, { useState, useEffect } from "react";
import CustomDataTable from "../../../../../partials/content/CustomDataTable";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import CustomerAddressForm from "./customerAddressForm";
import {
  getCustomerAddress,
  deleteCustomerAddress,
} from "../../../../../services/sales/customerService";
import ResponsiveEllipsis from "../../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { whatsappChat } from "../../../../../utils/utils";
import Swal from "sweetalert2";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
const CustomerAddresses = ({
  customerID,
  viewAuth = false,
  editAuth = false,
}) => {
  const { reload } = useGlobalData();
  const [openAddressForm, setOpenAddressForm] = useState(false);
  const [address, setAddress] = useState({});
  const [action, setAction] = useState("");
  const [auth, setAuth] = useState({});
  const [customerAddress, setCustomerAddress] = useState([]);

  useEffect(() => {
    getCustomerAddressData();
  }, [customerID, reload]);

  async function getCustomerAddressData() {
    const response = await getCustomerAddress(customerID);
    const { data, auth } = response.data;
    const { addresses } = data;
    setCustomerAddress(addresses);
    setAuth(auth);
  }

  const customerAddressDetailColumn = [
    {
      header: "Province / State",
      field: "province",
      type: "string",
    },
    {
      header: "Country",
      field: "countryName",
      type: "string",
    },
    {
      header: "Postal Code",
      field: "postalCode",
      type: "string",
    },
    {
      header: "Email",
      field: "addressEmail",
      type: "string",
    },
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <CustomDataTable
            data={customerAddress}
            dataDetailColumns={customerAddressDetailColumn}
            onRefreshData={() => {
              getCustomerAddressData();
            }}
            buttons={
              editAuth
                ? [
                    {
                      name: "New Address",
                      icon: "fas fa-plus-circle",
                      color: "primary",
                      onClick: () => {
                        setAction("create");
                        setAddress({});
                        setOpenAddressForm(true);
                      },
                    },
                  ]
                : []
            }
            columns={[
              {
                header: "Address Name",
                field: "addressName",
                body: (rowData) => {
                  return (
                    <React.Fragment>
                      {rowData.standardFlag ? (
                        <React.Fragment>
                          <span>
                            <BootstrapTooltip title="Standard record protection">
                              <span className="mr-2">
                                <i className="fas fa-shield-alt kt-font-brand"></i>
                              </span>
                            </BootstrapTooltip>
                            <span>{rowData.addressName}</span>
                          </span>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <ResponsiveEllipsis
                            text={rowData.addressName}
                            maxLine="1"
                          />
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  );
                },
                sortable: true,
                filter: true,
              },
              {
                header: "Address",
                field: "address",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.address} maxLine="1" />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "City",
                field: "city",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.city} maxLine="1" />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Phone Number",
                field: "addressPhone",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.addressPhone}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <React.Fragment>
                    {rowData.addressPhone !== "" ? (
                      <BootstrapTooltip title="Whatsapp Chat Customer Address">
                        <button
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            whatsappChat(rowData.addressPhone, `Hi customer`);
                          }}
                          className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                        >
                          <i className="flaticon-whatsapp"></i>
                        </button>
                      </BootstrapTooltip>
                    ) : null}
                    {editAuth && rowData.standardFlag === false ? (
                      <React.Fragment>
                        <BootstrapTooltip title="Edit Customer Address">
                          <button
                            type="button"
                            onClick={() => {
                              setAction("edit");
                              setAddress(rowData);
                              setOpenAddressForm(true);
                            }}
                            className="btn btn-icon btn-label-primary btn-circle btn-md mx-1"
                          >
                            <i className="fas fa-edit"></i>
                          </button>
                        </BootstrapTooltip>
                      </React.Fragment>
                    ) : null}
                    <BootstrapTooltip title="Customer Address Detail">
                      <button
                        type="button"
                        onClick={() => {
                          setAction("detail");
                          setAddress(rowData);
                          setOpenAddressForm(true);
                        }}
                        className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-list-alt"></i>
                      </button>
                    </BootstrapTooltip>
                    {editAuth && rowData.standardFlag === false ? (
                      <React.Fragment>
                        <BootstrapTooltip title="Delete Customer Address">
                          <button
                            type="button"
                            onClick={() =>
                              deleteCustomerAddressData(rowData.ID)
                            }
                            className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                          >
                            <i className="fas fa-trash-alt"></i>
                          </button>
                        </BootstrapTooltip>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                ),
                sortable: false,
              },
            ]}
          />
        </div>
      </div>
      <DialogLayout
        open={openAddressForm}
        title={
          action === "detail"
            ? "Customer Address Detail"
            : "Customer Address Form"
        }
        onCloseDialog={() => {
          setOpenAddressForm(false);
        }}
        maxWIdth="md"
      >
        <CustomerAddressForm
          customerID={customerID}
          action={action}
          address={address}
          onConfirmSave={() => {
            getCustomerAddressData();
            setOpenAddressForm(false);
          }}
          onCloseDialog={() => {
            setOpenAddressForm(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );

  async function deleteCustomerAddressData(customerAddressID) {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Customer Address ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteCustomerAddress(customerAddressID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            getCustomerAddressData();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }
};

export default CustomerAddresses;
